import type { Field, Fields } from '../../../types';
import { stringUtil } from './stringUtil';

export const getFieldOptions = <T extends string>(fields: Fields<T>, fieldKey: string) => {
  const field = fields.find(({ key }) => fieldKey === key) as Fields<T>[0];
  return field.fieldType.type === 'select' || field.fieldType.type === 'multiselect' ? field.fieldType.options : [];
};

export const getFieldSort = <T extends string>(fields: Fields<T>, fieldKey: string) => {
  const field = fields.find(({ key }) => fieldKey === key) as Fields<T>[0];
  return field.fieldType.type === 'select' || field.fieldType.type === 'multiselect' ? field.fieldType.sort : undefined;
};

export const hasMappedValue = <T extends string>(left: string, right: string, field: Field<T>) => {
  const caseInsensitiveValueMatch =
    field.fieldType.type === 'select' || field.fieldType.type === 'multiselect'
      ? (field.fieldType.caseInsensitiveValueMatch ?? false)
      : false;
  const targetLeft = stringUtil.unEscapedToSafe(stringUtil.escapedToSafe(left));
  const targetRight = stringUtil.unEscapedToSafe(stringUtil.escapedToSafe(right));

  if (caseInsensitiveValueMatch) {
    return targetLeft && targetRight ? targetLeft?.toUpperCase() === targetRight?.toUpperCase() : false;
  } else {
    return targetLeft === targetRight;
  }
};
